module.exports = __webpack_public_path__ + "static/media/8.ea1f3948.png";